<script setup lang="ts">
const props = defineProps<{
  source: 'trustpilot' | 'feedbackcompany'
}>()

const { storeConfig } = useStore()

// Fully defensive - return empty object instead of null
const reviewStats = computed(() => {
  if (!storeConfig?.value) return null
  const config = storeConfig.value as any

  if (props.source === 'trustpilot') {
    return config?.reviewStatsTrustPilot ?? null
  }
  return config?.reviewStatsFeedbackCompany ?? null
})

const shouldRender = computed(() => {
  return !!reviewStats.value?.score
})

const reviewLink = computed(() => {
  if (!reviewStats.value) return ''
  return reviewStats.value.websiteUrl ?? ''
})

// const stars = computed(() => {
//   if (!reviewStats.value) return 0
//   return Math.floor(reviewStats.value.score ?? 0)
// })

const score = computed(() => {
  if (!reviewStats.value) return 0
  return reviewStats.value.score ?? 0
})

const maxscore = computed(() => {
  if (!reviewStats.value) return 5
  return reviewStats.value.maxscore ?? 5
})

const total = computed(() => {
  if (!reviewStats.value) return 0
  return reviewStats.value.total ?? 0
})

const iconWide = computed(() => {
  return props.source === 'trustpilot'
    ? 'icon:labels-trustpilot-wide'
    : 'icon:labels-feedback-company-wide'
})

const iconSquare = computed(() => {
  return props.source === 'trustpilot'
    ? 'icon:labels-trustpilot-square'
    : 'icon:labels-feedback-company-square'
})
</script>

<template>
  <NuxtLink
    v-if="shouldRender"
    :to="reviewLink"
    class="review review__component"
    target="_blank"
    rel="noopener"
  >
    <NuxtIcon
      :name="iconWide"
      mode="svg"
      :class="iconWide"
    />
    <NuxtIcon
      :name="iconSquare"
      mode="svg"
      :class="iconSquare"
    />
    <ReviewStars
      class="review__stars"
      :rating="score/maxscore * 5"
    />
    <span class="review__scoring">
      <span class="review__score">{{ score }}</span>
      <span class="review__score">/</span>
      <span class="review__total"> {{ maxscore }} </span>
    </span>
    <span
      v-if="total > 0"
      class="review__totals"
    >
      <span class="review__review-count">{{ $t('{total} reviews', { total }) }}</span>
    </span>
  </NuxtLink>
</template>

<style>
@import url("~layers/components/Review/Component.css");
</style>
